import React, { useState, useEffect } from 'react';

export default function TreeResizeBar(props){

    // Function to handle resizing
    function initResize(event) {
        const container = event.target.parentElement;
        const childContainer = event.target.parentElement.querySelector('ul');

        const startX = event.clientX;
        const startWidth = parseInt(getComputedStyle(container).width, 10);
        const startLeft = childContainer ? parseInt(getComputedStyle(childContainer).left, 10) : 0;

        function resize(event) {
            const expandedWidth = (event.clientX - startX)
            let newWidth = startWidth + expandedWidth;
            if(newWidth < props.minWidth){
                newWidth = props.minWidth;
            }
            container.style.width = newWidth + 'px';
            if(childContainer){
                let newLeft = startLeft + expandedWidth;
                if(newLeft < props.minWidth){
                    newLeft = props.minWidth;
                }
                childContainer.style.left = newLeft + 'px';
            }
        }

        function stopResize() {
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize);
        }

        window.addEventListener('mousemove', resize);
        window.addEventListener('mouseup', stopResize);
    }

    useEffect(() => {
        const resizer = document.querySelector("#cw-level-"+props.level);
        if(resizer){
            resizer.addEventListener('mousedown', initResize);
        }
    },[]);

    return (
        <div className="resizer" id={"cw-level-"+props.level}></div>
    );
}